import React from 'react'

export default () => {
  return <h3>Please create a product support ticket</h3>
}